// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"97ea26f4","322":"162b5d03","963":"bf106d85"}[chunkId] + ".chunk.js";
};